import { ChemicalExposurePlacement } from '../enums/chemical-exposure-placement.enum';

export function chemicalExposurePlacementLabel(placement: number): 'inside' | 'outside' | '' {
  if (placement === ChemicalExposurePlacement.Inside) {
    return 'inside';
  }
  if (placement === ChemicalExposurePlacement.Outside) {
    return 'outside';
  }
  return '';
}
